import React, { useState, useEffect } from 'react'
import queryString from 'query-string'
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap'

import InputGroup from '../../../common/InputGroup'
import { notificationSuccess } from '../../../utils/customToastify'

const ReportAbuse = ({ history, match, addHistoryClick }) => {
  const [email, setEmail] = useState('')
  const [isAbused, setIsAbused] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = () => {
    const parsedSearch = queryString.parse(history.location.search)
    setEmail(parsedSearch.email)
  }

  const onReportAbuseClick = async () => {
    const decodedSearch = queryString.parse(history.location.search)
    const { token } = match.params
    await addHistoryClick(token, decodedSearch.redirectLink)
    setIsAbused(true)
    notificationSuccess('You just reported abuse!')
  }

  const onGoBackClick = () => {
    window.close()
    return false
  }
  return (
    <>
      <Row>
        <Col>
          <Button className='btn btn-sm gold-color-button mt-2 ml-2' onClick={onGoBackClick}>
            <i class='fas fa-arrow-left mr-2'></i> Go back to email
          </Button>
        </Col>
      </Row>
      <div className='centered'>
        <Row>
          <Col md='4'></Col>
          <Col md='4'>
            <Card>
              <CardHeader>Verified Report Abuse</CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    If you think your email address is being abused, please click the <strong>Report abuse</strong>{' '}
                    button to lodge an abuse complaint against this sender
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <InputGroup
                      label='Email Address'
                      placeholder='Email Address'
                      name='email'
                      onChange={() => {}}
                      value={email}
                      disabled
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className='btn btn-sm gold-color-button btn-block'
                      onClick={onReportAbuseClick}
                      disabled={isAbused}
                    >
                      Report Abuse
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col md='4'></Col>
        </Row>
      </div>
    </>
  )
}

export default ReportAbuse
